export class FetchLocationStateError extends Error {

}
